import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Suspense, useState } from 'react'
import Experience from './Experience.jsx'
import Loader from './Loader.jsx'

function App() {
    const [isLoaded, setIsLoaded] = useState(false)

    return (
        <>
            <Loader onComplete={() => setIsLoaded(true)} />
            <div className={`canvas-container ${isLoaded ? 'visible' : ''}`}>
                <Canvas
                    className="r3f"
                    camera={{
                        fov: 45,
                        near: 0.1,
                        far: 2000,
                        position: [-3, 1.5, 4]
                    }}
                >
                    <Suspense fallback={null}>
                        <Experience />
                    </Suspense>
                </Canvas>
            </div>
        </>
    )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)